import { render, staticRenderFns } from "./pageAstanaHUB.vue?vue&type=template&id=171afcac&scoped=true"
import script from "./pageAstanaHUB.vue?vue&type=script&lang=js"
export * from "./pageAstanaHUB.vue?vue&type=script&lang=js"
import style0 from "./pageAstanaHUB.vue?vue&type=style&index=0&id=171afcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171afcac",
  null
  
)

export default component.exports